/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FeedbackQueryResult from './FeedbackQueryResult';

/**
 * The FeedbackOutputCmsFeedback model module.
 * @module model/FeedbackOutputCmsFeedback
 * @version 1.0
 */
class FeedbackOutputCmsFeedback {
    /**
     * Constructs a new <code>FeedbackOutputCmsFeedback</code>.
     * @alias module:model/FeedbackOutputCmsFeedback
     */
    constructor() { 
        
        FeedbackOutputCmsFeedback.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FeedbackOutputCmsFeedback</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FeedbackOutputCmsFeedback} obj Optional instance to populate.
     * @return {module:model/FeedbackOutputCmsFeedback} The populated <code>FeedbackOutputCmsFeedback</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FeedbackOutputCmsFeedback();

            if (data.hasOwnProperty('feedback')) {
                obj['feedback'] = FeedbackQueryResult.constructFromObject(data['feedback']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/FeedbackQueryResult} feedback
 */
FeedbackOutputCmsFeedback.prototype['feedback'] = undefined;






export default FeedbackOutputCmsFeedback;

